import { render, staticRenderFns } from "./ClientInvitePage.vue?vue&type=template&id=5647a94a"
import script from "./ClientInvitePage.vue?vue&type=script&lang=ts"
export * from "./ClientInvitePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports